export default __webpack_public_path__ + "static/media/initial-divisor-bg.0928d886.png";